import clsx from 'clsx';
import React, { useEffect, useRef } from 'react';

import { withStyles } from '@material-ui/core';

import styles from './style';
import useHeaderSnackbar from '../../hooks/useHeaderSnackbar';
import { isIOSNativeEnvironment } from '../../utils/nativeBridge';

const Header = ({
  classes,
  isDesktop,
  propertySelectLayout,
  setHeaderHeight,
  headerChild,
  headerSearch,
}) => {
  const mobHeaderRef = useRef(null);
  const { snackbarHeight } = useHeaderSnackbar();
  const isIOSNative = isIOSNativeEnvironment();
  const headerHeight = 59;

  useEffect(() => {
    if (setHeaderHeight) {
      setHeaderHeight(
        mobHeaderRef.current.offsetHeight + snackbarHeight + headerHeight
      );
    }
  }, [mobHeaderRef.current?.offsetHeight, snackbarHeight]);

  return (
    <div
      ref={mobHeaderRef}
      className={clsx([
        classes.header,
        propertySelectLayout && classes.propertyAlign,
        isDesktop && !propertySelectLayout && 'hide',
        !headerSearch && 'hide',
      ])}
      style={{ top: snackbarHeight + headerHeight }}
    >
      {isIOSNative && snackbarHeight === 0 && (
        <div className={classes.iosNativeNotch} />
      )}

      {headerSearch && (
        <div className="flex gap-[7px] font-circular">{headerSearch}</div>
      )}
      {headerChild && headerChild}
    </div>
  );
};

export default withStyles(styles)(Header);
